import type { RoadData } from '../core/domain/Roaddata';

export const resolveRoadDataColor = (roadData?: RoadData): string | undefined => {
    if (!roadData?.reference) {
        return 'lightblue';
    }

    return roadData.reference.color ?? 'lightblue';
};
